<template>
	<div>
		<div v-if="stage == 'pincode'" class="sub-container">
			<h1 class="title is-2">
				{{ $t('voting') }}
			</h1>

			<p class="mb-5">
				{{ $t('pincode_explanation') }}
			</p>

			<h2 class="title is-3">
				{{ $t('enter_pincode') }}
			</h2>

			<div class="field" style="max-width: 300px; margin: 0 auto;">
				<div class="control is-large" :class="[{ 'is-loading': stage == 'check_pincode' }]">
					<input class="input is-large" type="text" v-model="pincode" placeholder="Шесть цифр">
				</div>
			</div>

		</div>
		<div v-if="stage == 'vote'" class="sub-container">
			<h1 class="title is-2">
				{{ $t('voting') }}
			</h1>

			<movie v-for="movie, index in movies" :ticket="ticket" :movie="movie" :key="index" @set-vote="setMovieVote" />

			<footer>
				<div class="box" style="max-width: 960px; margin: 0 auto; box-shadow: 0 0 10px rgba(0,0,0,0.5); display: flex; justify-content: space-between; align-items: center;">
					<div style="width: 100px;">
						<template v-if="session_closes_at">
							{{ $t('voting_time_left') }} 
							<span style="font-size: 20px;">
								{{ countdown }}
							</span>
						</template>
					</div>
					<div>
						{{ $t('total_rates') }}
						<br>
						<span style="font-size: 20px;">
							{{ votes.length }} {{ $t('out_of') }} {{ movies.length }}
						</span>
					</div>
					<div>
						<button class="button is-success is-rounded is-medium" :class="[{ 'is-loading': isLoading }]" :disabled="votes.length != movies.length" @click="sendVote">
							<span>
								{{ $t('send') }}
							</span>
						</button>
					</div>
				</div>
			</footer>

		</div>
		<div v-if="stage == 'bluff'" class="sub-container">
			<h1>
				<template v-if="bluff.title">
					{{ $t(bluff.title) }}
				</template>
			</h1>
			<p class="mb-3" v-if="bluff.message">
				{{ $t(bluff.message) }}
			</p>

			<template v-if="bluff.button">
				<button class="button" @click="reloadPage()" v-if="bluff.button == 'reload'">
					{{ $t('reload') }}
				</button>
				<span v-else-if="bluff.button == 'results'">
					<router-link href="#" class="button" :to="{ name: 'StageResults', params: { stage: stage_id } }">
						{{ $t('voting_results') }}
					</router-link>
				</span>
				<span v-else-if="bluff.button == 'home'">
					<router-link href="#" class="button" :to="{ name: 'Home' }">
						{{ $t('to_home') }}
					</router-link>
				</span>
			</template>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Movie from './Movie'
import { useCookies } from "vue3-cookies";

export default{
	props: {
		ticket: {
			required: true
		}
	},
	components: {
		Movie
	},
	setup() {
		const { cookies } = useCookies();
		return { cookies };
	},
	data(){
		return {
			stage: 'prepare',
			pincode: null,
			bluff: null,
			movies: null,
			votes: [],
			isLoading: false,
			stage_id: null,
			session_closes_at: null,
			countdown: null,
			TMID: null
		}
	},
	watch: {
		pincode: function(val){
			if(val.length == 6){
				this.stage = 'check_pincode'
				this.check_pincode()
			}
		}
	},
	mounted(){
		this.prepare()

		window.Echo.channel('movie-session-change-state').listen('MovieSessionChangeState', data => {

			this.session_closes_at = data.payload.movie_session.auto_close_at

			if(!data.payload.movie_session.auto_close_at){
				clearTimeout(this.TMID)
			} else {
				if(!this.TMID){
					this.startTimer()
				}
			}

			if(data.payload.movie_session.closed_at && (this.stage == 'vote' || this.stage == 'prepare' || this.stage == 'pincode')){
				clearTimeout(this.TMID)
				location.reload()
			}

			//this.updateMovieSession(data.payload.movie_session)
		});
	},
	methods: {
		setMovieVote(data){
			let index = this.votes.findIndex(vote => {
				return vote.movie_id == data.movie_id
			})

			if(index < 0){
				this.votes.push(data)
			} else {
				this.votes.splice(index, 1, data)
			}
		},
		reloadPage(){
			location.reload()
		},
		async prepare(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/tickets/${this.ticket}`).then(r => {
				if(r.data.result == 'ok' && r.data.proceed_to == 'pincode'){
					this.stage = 'pincode'
				} else if(r.data.result == 'ok' && r.data.proceed_to == 'virtual_vote'){
					this.pincode = r.data.pincode
				} else {
					this.stage = 'bluff'
					this.bluff = r.data
				}

				this.stage_id = r.data.stage_id
				if(r.data.auto_close_at){
					this.session_closes_at = r.data.auto_close_at

					this.startTimer()
				}
			})
		},
		startTimer(){
			this.TMID = setInterval(() => {
				var duration = moment.duration(moment(this.session_closes_at).diff(moment()));
				var seconds = duration.asSeconds();

				if(seconds < 0){
					seconds = 0
				}
				this.countdown = moment.utc(seconds*1000).format('HH:mm:ss')

				if(seconds == 120){
					alert(this.$t('2_minutes_left'))
				}

			}, 1000)
		},
		async check_pincode(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/tickets/${this.ticket}/${this.pincode}`).then(r => {
				if(r.data.result == 'ok' && r.data.proceed_to == 'vote'){
					this.stage = 'vote'
					this.movies = r.data.movies
				} else {
					this.stage = 'bluff'
					this.bluff = r.data
				}
			})
		},
		async sendVote(){
			this.isLoading = true
			await axios.post(`${process.env.VUE_APP_API_LOCATION}/api/tickets/${this.ticket}/vote`, { votes: this.votes }).then(r => {
				if(r.data.result == 'ok'){
					this.cookies.set("voted_ticket_session_"+r.data.movie_session_id, this.ticket, 60 * 60 * 24 * 30)
					location.reload()
				} else {
					this.stage = 'bluff'
					this.bluff = r.data	
				}
				this.isLoading = false
			})
		}
	}
}
</script>
<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.starability-growRotate.rating{
	width: 280px !important;
	margin: 0 auto !important;
}

.sub-container{
	max-width: 500px; margin: 0 auto;
}
.sub-container > p,
.sub-container > h1,
.sub-container > h2{
	color: #fff !important;
}
.container h1{
	font-size: 60px;
}
.container p{
	font-size: 20px;
}

footer{
	position: fixed;
	bottom: 10px;
	left: 0;
	width: 100%;
}
.starability-growRotate label{
    color: #fff;
    padding: 7px;
    font-size: 12px;
}

.container .card-content .starability-growRotate.rating{
	width: 280px !important;
}
.container .card-content > div *,
.container .box .title, .container .box .movie-description, .container .box .movie-length{
	color: #333 !important;
}
.starability-growRotate.rating legend{
	margin-bottom: 5px;
}
.movie-description p{
	font-size: 14px !important;
}
</style>